(function(){
  if(window.__dcInit) return; window.__dcInit = true;
  function ytId(u){ if(!u) return ''; var m=String(u).match(/(?:youtu\.be\/|[?&]v=|embed\/|shorts\/)([\w-]{11})/); return m?m[1]:''; }
  function vimeoId(u){ var m=String(u).match(/vimeo\.com\/(?:video\/)?(\d+)/); return m?m[1]:''; }
  function loadVideos(modal){
    modal.querySelectorAll('.dc-video[data-video]').forEach(function(v){
      if(v.dataset.loaded) return;
      var url=v.getAttribute('data-video'); var yt=ytId(url); var vi=vimeoId(url); var src='';
      if(yt) src='https://www.youtube.com/embed/'+yt+'?autoplay=1&playsinline=1&rel=0';
      else if(vi) src='https://player.vimeo.com/video/'+vi+'?autoplay=1&playsinline=1';
      if(src){
        var ifr=document.createElement('iframe');
        ifr.src=src; ifr.setAttribute('allowfullscreen','');
        ifr.setAttribute('allow','accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
        v.appendChild(ifr); v.dataset.loaded='1';
      } else if(/\.(mp4|webm|mov|m4v)(\?|#|$)/i.test(url)){
        var vid=document.createElement('video');
        vid.src=url; vid.controls=true; vid.playsInline=true; vid.setAttribute('playsinline',''); vid.preload='auto';
        v.appendChild(vid); v.dataset.loaded='1';
        var p=vid.play(); if(p&&p.catch) p.catch(function(){});
      } else if(url){
        v.innerHTML='<div class="dc-video--empty" style="position:absolute;inset:0;">Video-Link nicht erkannt</div>'; v.dataset.loaded='1';
      }
    });
  }
  var pdfjsReady=null;
  function loadPdfJs(){
    if(pdfjsReady) return pdfjsReady;
    pdfjsReady=new Promise(function(res,rej){
      if(window.pdfjsLib){ res(); return; }
      var s=document.createElement('script');
      s.src='https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js';
      s.onload=function(){ try{ window.pdfjsLib.GlobalWorkerOptions.workerSrc='https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js'; }catch(e){} res(); };
      s.onerror=rej; document.head.appendChild(s);
    });
    return pdfjsReady;
  }
  function fallbackLink(el,url){ el.classList.add('dc-pdf--err'); el.innerHTML='<a class="dc-dl" href="'+url+'" target="_blank" rel="noopener">PDF öffnen</a>'; }
  function renderPdf(el,url){
    var w=(el.clientWidth||600)-28; if(w<200) w=600;
    var dpr=window.devicePixelRatio||1;
    window.pdfjsLib.getDocument(url).promise.then(function(pdf){
      el.innerHTML=''; var max=Math.min(pdf.numPages,15); var chain=Promise.resolve();
      for(var i=1;i<=max;i++){ (function(n){ chain=chain.then(function(){ return pdf.getPage(n).then(function(page){
        var base=page.getViewport({scale:1}); var scale=w/base.width; var vp=page.getViewport({scale:scale*dpr});
        var c=document.createElement('canvas'); c.width=vp.width; c.height=vp.height; c.style.width='100%'; c.style.height='auto';
        el.appendChild(c); return page.render({canvasContext:c.getContext('2d'),viewport:vp}).promise;
      }); }); })(i); }
      chain.catch(function(){});
    }).catch(function(){ fallbackLink(el,url); });
  }
  function loadPdfs(modal){
    var els=modal.querySelectorAll('.dc-pdf[data-pdf]'); if(!els.length) return;
    loadPdfJs().then(function(){ els.forEach(function(el){ if(el.dataset.loaded) return; el.dataset.loaded='1'; renderPdf(el,el.getAttribute('data-pdf')); }); })
    .catch(function(){ els.forEach(function(el){ if(el.dataset.loaded) return; el.dataset.loaded='1'; fallbackLink(el,el.getAttribute('data-pdf')); }); });
  }
  function openModal(m){ m.classList.add('is-open'); document.body.style.overflow='hidden'; loadVideos(m); loadPdfs(m);
    m.querySelectorAll('video').forEach(function(v){ try{ var p=v.play(); if(p&&p.catch) p.catch(function(){}); }catch(e){} });
  }
  function closeModal(m){ m.classList.remove('is-open');
    if(!document.querySelector('.dc-modal.is-open')){ document.body.style.overflow=''; }
    m.querySelectorAll('video').forEach(function(v){ try{v.pause();}catch(e){} });
    m.querySelectorAll('.dc-video[data-video] iframe').forEach(function(f){ var v=f.parentNode; v.removeChild(f); delete v.dataset.loaded; });
  }
  document.addEventListener('click', function(e){
    var zoom=e.target.closest('[data-dc-zoom]');
    if(zoom){ var lb=document.getElementById('dc-lightbox'); if(lb){ var im=lb.querySelector('img'); im.src=zoom.getAttribute('data-dc-zoom'); openModal(lb); } return; }
    var op=e.target.closest('[data-dc-open]');
    if(op){ var m=document.getElementById(op.getAttribute('data-dc-open')); if(m){ openModal(m); } return; }
    if(e.target.closest('[data-dc-close]')){ var md=e.target.closest('.dc-modal'); if(md) closeModal(md); return; }
    if(e.target.classList && e.target.classList.contains('dc-modal')){ closeModal(e.target); }
  });
  document.addEventListener('keydown', function(e){
    if(e.key==='Escape'){
      var open=document.querySelectorAll('.dc-modal.is-open');
      if(open.length){ closeModal(open[open.length-1]); }
    }
  });
})();
